/* FSC mobile filter + sort tray. Deferred, dependency-free, one delegated listener set. */
(function () {
  var root = document.querySelector('[data-fsc-mf]');
  if (!root) return;

  var tray = root.querySelector('[data-fsc-tray]');
  var form = root.querySelector('[data-fsc-form]');
  var baseUrl = root.getAttribute('data-url') || location.pathname;
  var counts = root.querySelectorAll('[data-fsc-count]');
  var applyBtn = form.querySelector('.fsc-mf__apply');
  var timer = 0;
  var controller = null;
  var lastQuery = null;

  function query() {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      if (value !== '') params.append(key, value);
    });
    return params.toString();
  }

  function setTab(name) {
    root.querySelectorAll('[data-fsc-tab]').forEach(function (tab) {
      var on = tab.getAttribute('data-fsc-tab') === name;
      tab.setAttribute('aria-selected', on);
      tab.tabIndex = on ? 0 : -1;
      document.getElementById(tab.getAttribute('aria-controls')).hidden = !on;
    });
  }

  function open(tab) {
    setTab(tab);
    lastQuery = query();
    if (typeof tray.showModal === 'function') tray.showModal();
    else tray.setAttribute('open', '');
    document.documentElement.classList.add('fsc-mf-lock');
  }

  function close() {
    if (tray.open) tray.close();
    document.documentElement.classList.remove('fsc-mf-lock');
  }

  // Live result count: debounced, async, abortable, tiny payload (count-only section).
  function refreshCount() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      var q = query();
      if (q === lastQuery) return;
      lastQuery = q;
      if (controller) controller.abort();
      controller = new AbortController();
      applyBtn.setAttribute('aria-busy', 'true');
      var url = baseUrl + '?' + (q ? q + '&' : '') + 'sections=fsc-facet-count';
      fetch(url, { signal: controller.signal, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          var m = /data-count="(\d+)"/.exec(json['fsc-facet-count'] || '');
          if (m) counts.forEach(function (el) { el.textContent = m[1]; });
        })
        .catch(function () {})
        .then(function () { applyBtn.removeAttribute('aria-busy'); });
    }, 250);
  }

  function filterYears() {
    var list = root.querySelector('[data-fsc-years]');
    if (!list) return;
    var search = root.querySelector('[data-fsc-year-search]');
    var term = search ? search.value.trim() : '';
    var active = root.querySelector('[data-fsc-decade][aria-pressed="true"]');
    var decade = active ? active.getAttribute('data-fsc-decade') : '';
    list.querySelectorAll('li').forEach(function (li) {
      var y = li.getAttribute('data-year') || '';
      li.hidden = (term && y.indexOf(term) === -1) || (decade && y.indexOf(decade) !== 0);
    });
  }

  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-fsc-open],[data-fsc-close],[data-fsc-tab],[data-fsc-clear],[data-fsc-decade]');
    if (!t) return;
    if (t.hasAttribute('data-fsc-open')) open(t.getAttribute('data-fsc-open'));
    else if (t.hasAttribute('data-fsc-close')) close();
    else if (t.hasAttribute('data-fsc-tab')) setTab(t.getAttribute('data-fsc-tab'));
    else if (t.hasAttribute('data-fsc-decade')) {
      var on = t.getAttribute('aria-pressed') !== 'true';
      root.querySelectorAll('[data-fsc-decade]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      t.setAttribute('aria-pressed', on);
      filterYears();
    } else if (t.hasAttribute('data-fsc-clear')) {
      form.querySelectorAll('input[type=checkbox]').forEach(function (i) { i.checked = false; });
      form.querySelectorAll('input[type=number]').forEach(function (i) { i.value = ''; });
      refreshCount();
    }
  });

  form.addEventListener('change', function (e) {
    if (e.target.name === 'sort_by') return; // sort doesn't change the count
    refreshCount();
  });

  form.addEventListener('input', function (e) {
    if (e.target.hasAttribute('data-fsc-year-search')) filterYears();
    else if (e.target.type === 'number') refreshCount();
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var q = query();
    location.href = baseUrl + (q ? '?' + q : '');
  });

  // Close on backdrop tap / Escape
  tray.addEventListener('click', function (e) { if (e.target === tray) close(); });
  tray.addEventListener('close', function () { document.documentElement.classList.remove('fsc-mf-lock'); });
})();
